interface SectionCopyIconProps {
  width?: number;
  height?: number;
  fill?: string;
}

const SectionCopyIcon = ({ 
  width = 18, 
  height = 18, 
  fill = "rgba(102, 21, 149, 0.6)"
}: SectionCopyIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M11.7 0H2.7C2.09674 0 1.51849 0.239642 1.09091 0.666116C0.663342 1.09259 0.423706 1.66957 0.423706 2.27143V15.2571H2.7V2.27143H11.7V0ZM14.4 4.54286H6.3C5.69674 4.54286 5.11849 4.7825 4.69091 5.20897C4.26334 5.63545 4.02371 6.21243 4.02371 6.81429V15.7286C4.02371 16.3304 4.26334 16.9074 4.69091 17.3339C5.11849 17.7604 5.69674 18 6.3 18H14.4C15.0033 18 15.5815 17.7604 16.0091 17.3339C16.4367 16.9074 16.6763 16.3304 16.6763 15.7286V6.81429C16.6763 6.21243 16.4367 5.63545 16.0091 5.20897C15.5815 4.7825 15.0033 4.54286 14.4 4.54286Z"
        fill={fill}
      />
    </svg>
  );
};

export default SectionCopyIcon;
